import { React, useState } from 'react';

export default function Song(props) {
  const [clicked, isClicked] = useState(false);
  let clickVisibility = clicked ? 'block' : 'none';

  let toggleData = () => {
    isClicked(!clicked);
  };

  let getPeakData = (songName) => {
    let tens = props.data['tens'];
    let peakDate;
    for (var key in tens) {
      if (tens.hasOwnProperty(key) && key === songName) {
        peakDate = tens[key]['Peak date'];
      }
    }
    return peakDate;
  };

  let getWeeksData = (songName) => {
    let tens = props.data['tens'];
    let weeks;
    for (var key in tens) {
      if (tens.hasOwnProperty(key) && key === songName) {
        // weeks = tens[key][1];
        weeks = tens[key]['Weeks on chart'];
      }
    }
    return weeks;
  };

  let getPeakPosition = (songName) => {
    let tens = props.data['tens'];
    let peakPosition;
    for (var key in tens) {
      if (tens.hasOwnProperty(key) && key === songName) {
        // peakPosition = tens[key][2];
        peakPosition = tens[key]['Peak Position'];
      }
    }
    return peakPosition;
  };

  let getDuoSongName = (songName) => {
    let tens = props.data['tens'];
    let artistsInvolved;
    for (var key in tens) {
      if (tens.hasOwnProperty(key) && key === songName) {
        // artistsInvolved = tens[key][3];
        artistsInvolved = tens[key]['Featured'];
      }
    }
    return artistsInvolved;
  };

  let glowClass =
    getPeakPosition(props.song) === 1 ? 'glow-effect' : 'glow-less';
  glowClass = `song ${glowClass}`;

  return (
    <div onClick={toggleData}>
      <li key={props.song} className={glowClass}>
        {props.song}
      </li>
      <div class='songStats' style={{ display: clickVisibility }}>
        <p>
          Peak Position:{' '}
          <span style={{ fontFamily: 'SF-Pro-Display-Bold' }}>
            {getPeakPosition(props.song)}
          </span>
        </p>
        <p>Peak Date: {getPeakData(props.song)}</p>
        <p>Weeks On Charts: {getWeeksData(props.song)}</p>
        {!props.amISolo ? (
          <p className='featuredArtistDiv'>
            Artists: {getDuoSongName(props.song)}
          </p>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}
